import { render, staticRenderFns } from "./AdvancedConfiguration.vue?vue&type=template&id=0a2c265a&scoped=true&"
import script from "./AdvancedConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AdvancedConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c265a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VDivider,VForm,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2c265a')) {
      api.createRecord('0a2c265a', component.options)
    } else {
      api.reload('0a2c265a', component.options)
    }
    module.hot.accept("./AdvancedConfiguration.vue?vue&type=template&id=0a2c265a&scoped=true&", function () {
      api.rerender('0a2c265a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/AdvancedConfiguration.vue"
export default component.exports